import LocalStorage from '../data/local-storage';
import IndexedDB from '../data/indexed-db';
import AuthService from './auth-service';
import { escapeHtml, getAvatarUrl } from '../utils/helpers';
import * as UIService from './ui-service';

class BookmarkService {
  constructor() {
    this.bookmarks = [];
  }

  async load() {
    const stored = await IndexedDB.get(this.getKey());
    if (stored && Array.isArray(stored)) {
      this.bookmarks = stored;
    } else {
      const local =
        LocalStorage.getUserSpecificObject('heliaedu_user_bookmarks', AuthService.user.id) || [];
      this.bookmarks = local;
      if (local.length > 0) IndexedDB.set(this.getKey(), local);
    }
  }

  getKey() {
    return LocalStorage.getUserSpecificKey('heliaedu_user_bookmarks', AuthService.user.id);
  }

  getBookmarks() {
    return this.bookmarks;
  }

  setBookmarks(bookmarks) {
    this.bookmarks = bookmarks;
    IndexedDB.set(this.getKey(), bookmarks);
  }

  createBookmarkFromStory(story) {
    return {
      storyId: story.id,
      userName: story.name,
      userPhoto: getAvatarUrl(story.name),
      description: story.description,
      photoUrl: story.photoUrl,
      lat: story.lat,
      lon: story.lon,
      savedAt: new Date().toISOString(),
    };
  }

  addBookmark(story) {
    const bookmarks = this.getBookmarks();
    const bookmark = this.createBookmarkFromStory(story);
    bookmarks.push(bookmark);
    this.setBookmarks(bookmarks);
    return bookmark;
  }

  removeBookmark(storyId) {
    const bookmarks = this.getBookmarks().filter((b) => b.storyId !== storyId);
    this.setBookmarks(bookmarks);
    return bookmarks.length;
  }

  updateBubble() {
    const container = document.querySelector('#bookmark-content');
    if (!container) return;
    const bookmarks = this.getBookmarks();
    container.innerHTML = '';
    if (bookmarks.length === 0) {
      container.innerHTML = `<div class="bookmark-null"><span class="material-symbols-rounded" aria-hidden="true">bookmarks</span><p>Anda belum menyimpan apapun</p></div>`;
    } else {
      const recent = bookmarks.sort((a,b) => new Date(b.savedAt)-new Date(a.savedAt)).slice(0,5);
      let html = '';
      recent.forEach(b => {
        html += `<a href="#/post/${b.storyId}" class="bookmark-preview"><div class="bookmark-sender"><div class="bookmark-photo"><img src="${b.userPhoto}" alt="${b.userName}" width="32" height="32" loading="lazy"></div><div class="bookmark-name"><strong>${b.userName}</strong></div></div><div class="preview-bookmark"><p>${escapeHtml(b.description).substring(0,60)}${b.description.length>60?'...':''}</p></div></a>`;
      });
      container.innerHTML = html;
    }
    UIService.reinitTooltips();
  }
}

export default new BookmarkService();
